import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Reload = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M29 16a13 13 0 01-18.48 11.79 1 1 0 11.85-1.79A11 11 0 105 16c0 .35 0 .7.05 1l1.11-1.68a1 1 0 111.67 1.11l-2.65 4a1 1 0 01-.74.44h-.1a1 1 0 01-.71-.29L.29 17.26a1 1 0 011.42-1.41l1.35 1.36C3 16.81 3 16.4 3 16a13 13 0 0126 0z" })), '0 0 32 32', 'Reload');
//# sourceMappingURL=Reload.js.map